import type { Action } from "redux"

import { Recipe, FavoriteRecipesData } from "../../types"

export enum FavoriteRecipesActionTypes {
    GetAllFavoriteRecipesLoading = "favorite-recipes:get-all-loading",
    GetAllFavoriteRecipesLoaded = "favorite-recipes:get-all-loaded",
    GetAllFavoriteRecipesError = "favorite-recipes:get-all-error",
    GetAllFavoriteRecipesSuccess = "favorite-recipes:get-all-success",
    GetAllFavoriteRecipesFromCache = "favorite-recipes:get-all-from-cache",
    CreateFavoriteRecipeLoading = "favorite-recipes:create-loading",
    CreateFavoriteRecipeLoaded = "favorite-recipes:create-loaded",
    CreateFavoriteRecipeError = "favorite-recipes:create-error",
    CreateFavoriteRecipesSuccess = "favorite-recipes:create-multiple-success",
    CreateFavoriteRecipesLoading = "favorite-recipes:create-multiple-loading",
    CreateFavoriteRecipesLoaded = "favorite-recipes:create-multiple-loaded",
    CreateFavoriteRecipesError = "favorite-recipes:create-multiple-error",
    CreateFavoriteRecipeSuccess = "favorite-recipes:create-success",
    RemoveFavoriteRecipeLoading = "favorite-recipes:remove-loading",
    RemoveFavoriteRecipeLoaded = "favorite-recipes:remove-loaded",
    RemoveFavoriteRecipeError = "favorite-recipes:remove-error",
    RemoveFavoriteRecipeSuccess = "favorite-recipes:remove-success",
    TransferRecipeToFavorites = "favorite-recipes:transfer",
    UnloadFavoriteRecipes = "favorite-recipes:unload",
}

interface ActionWithPayload<TAction, TPayload> extends Action<TAction> {
    payload: TPayload
}

export type GetAllFavoriteRecipesLoading =
    Action<FavoriteRecipesActionTypes.GetAllFavoriteRecipesLoading>
export const getAllFavoriteRecipesLoading = (): GetAllFavoriteRecipesLoading => ({
    type: FavoriteRecipesActionTypes.GetAllFavoriteRecipesLoading,
})

export type GetAllFavoriteRecipesLoaded =
    Action<FavoriteRecipesActionTypes.GetAllFavoriteRecipesLoaded>
export const getAllFavoriteRecipesLoaded = (): GetAllFavoriteRecipesLoaded => ({
    type: FavoriteRecipesActionTypes.GetAllFavoriteRecipesLoaded,
})

export type GetAllFavoriteRecipesSuccess = ActionWithPayload<
    FavoriteRecipesActionTypes.GetAllFavoriteRecipesSuccess,
    FavoriteRecipesData
>
export const getAllFavoriteRecipesSuccess = (
    data: FavoriteRecipesData,
): GetAllFavoriteRecipesSuccess => ({
    type: FavoriteRecipesActionTypes.GetAllFavoriteRecipesSuccess,
    payload: data,
})
export type GetAllFavoriteRecipesFromCache = ActionWithPayload<
    FavoriteRecipesActionTypes.GetAllFavoriteRecipesFromCache,
    FavoriteRecipesData
>
export const getAllFavoriteRecipesFromCache = (
    data: FavoriteRecipesData,
): GetAllFavoriteRecipesFromCache => ({
    type: FavoriteRecipesActionTypes.GetAllFavoriteRecipesFromCache,
    payload: data,
})

export type GetAllFavoriteRecipesError = ActionWithPayload<
    FavoriteRecipesActionTypes.GetAllFavoriteRecipesError,
    Error
>
export const getAllFavoriteRecipesError = (error: Error): GetAllFavoriteRecipesError => ({
    type: FavoriteRecipesActionTypes.GetAllFavoriteRecipesError,
    payload: error,
})

export type CreateFavoriteRecipeLoading = ActionWithPayload<
    FavoriteRecipesActionTypes.CreateFavoriteRecipeLoading,
    string
>
export const createFavoriteRecipeLoading = (recipeId: string): CreateFavoriteRecipeLoading => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipeLoading,
    payload: recipeId,
})

export type CreateFavoriteRecipeLoaded =
    Action<FavoriteRecipesActionTypes.CreateFavoriteRecipeLoaded>
export const createFavoriteRecipeLoaded = (): CreateFavoriteRecipeLoaded => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipeLoaded,
})

export type CreateFavoriteRecipeSuccess = ActionWithPayload<
    FavoriteRecipesActionTypes.CreateFavoriteRecipeSuccess,
    string[]
>
export const createFavoriteRecipeSuccess = (data: string[]): CreateFavoriteRecipeSuccess => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipeSuccess,
    payload: data,
})

export type CreateFavoriteRecipeError = ActionWithPayload<
    FavoriteRecipesActionTypes.CreateFavoriteRecipeError,
    Error
>
export const createFavoriteRecipeError = (error: Error): CreateFavoriteRecipeError => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipeError,
    payload: error,
})

export type CreateFavoriteRecipesLoading = ActionWithPayload<
    FavoriteRecipesActionTypes.CreateFavoriteRecipesLoading,
    string[]
>
export const createFavoriteRecipesLoading = (
    recipeIds: string[],
): CreateFavoriteRecipesLoading => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipesLoading,
    payload: recipeIds,
})

export type CreateFavoriteRecipesLoaded =
    Action<FavoriteRecipesActionTypes.CreateFavoriteRecipesLoaded>
export const createFavoriteRecipesLoaded = (): CreateFavoriteRecipesLoaded => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipesLoaded,
})

export type CreateFavoriteRecipesSuccess = ActionWithPayload<
    FavoriteRecipesActionTypes.CreateFavoriteRecipesSuccess,
    string[]
>
export const createFavoriteRecipesSuccess = (data: string[]): CreateFavoriteRecipesSuccess => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipesSuccess,
    payload: data,
})

export type CreateFavoriteRecipesError = ActionWithPayload<
    FavoriteRecipesActionTypes.CreateFavoriteRecipesError,
    Error
>
export const createFavoriteRecipesError = (error: Error): CreateFavoriteRecipesError => ({
    type: FavoriteRecipesActionTypes.CreateFavoriteRecipesError,
    payload: error,
})

export type RemoveFavoriteRecipeLoading = ActionWithPayload<
    FavoriteRecipesActionTypes.RemoveFavoriteRecipeLoading,
    string
>
export const removeFavoriteRecipeLoading = (recipeId: string): RemoveFavoriteRecipeLoading => ({
    type: FavoriteRecipesActionTypes.RemoveFavoriteRecipeLoading,
    payload: recipeId,
})

export type RemoveFavoriteRecipeLoaded =
    Action<FavoriteRecipesActionTypes.RemoveFavoriteRecipeLoaded>
export const removeFavoriteRecipeLoaded = (): RemoveFavoriteRecipeLoaded => ({
    type: FavoriteRecipesActionTypes.RemoveFavoriteRecipeLoaded,
})

export type RemoveFavoriteRecipeSuccess = ActionWithPayload<
    FavoriteRecipesActionTypes.RemoveFavoriteRecipeSuccess,
    string
>
export const removeFavoriteRecipeSuccess = (data: string): RemoveFavoriteRecipeSuccess => ({
    type: FavoriteRecipesActionTypes.RemoveFavoriteRecipeSuccess,
    payload: data,
})

export type RemoveFavoriteRecipeError = ActionWithPayload<
    FavoriteRecipesActionTypes.RemoveFavoriteRecipeError,
    Error
>
export const removeFavoriteRecipeError = (error: Error): RemoveFavoriteRecipeError => ({
    type: FavoriteRecipesActionTypes.RemoveFavoriteRecipeError,
    payload: error,
})

export type TransferRecipeToFavorites = ActionWithPayload<
    FavoriteRecipesActionTypes.TransferRecipeToFavorites,
    Recipe
>
export const transferRecipeToFavorites = (recipe: Recipe): TransferRecipeToFavorites => ({
    type: FavoriteRecipesActionTypes.TransferRecipeToFavorites,
    payload: recipe,
})

export type UnloadFavoriteRecipes = Action<FavoriteRecipesActionTypes.UnloadFavoriteRecipes>
export const unloadFavoriteRecipes = (): UnloadFavoriteRecipes => ({
    type: FavoriteRecipesActionTypes.UnloadFavoriteRecipes,
})

export type FavoriteRecipesActions =
    | GetAllFavoriteRecipesLoading
    | GetAllFavoriteRecipesLoaded
    | GetAllFavoriteRecipesError
    | GetAllFavoriteRecipesSuccess
    | GetAllFavoriteRecipesFromCache
    | CreateFavoriteRecipeLoading
    | CreateFavoriteRecipeLoaded
    | CreateFavoriteRecipeError
    | CreateFavoriteRecipeSuccess
    | CreateFavoriteRecipesLoading
    | CreateFavoriteRecipesLoaded
    | CreateFavoriteRecipesError
    | CreateFavoriteRecipesSuccess
    | RemoveFavoriteRecipeLoading
    | RemoveFavoriteRecipeLoaded
    | RemoveFavoriteRecipeError
    | RemoveFavoriteRecipeSuccess
    | TransferRecipeToFavorites
    | UnloadFavoriteRecipes
